import { app } from '@/app'

// Store created containers to avoid recreating
const createdContainers = new Set<string>()

// Function to ensure a popper container exists
function ensurePopperContainer(containerId: string) {
  if (createdContainers.has(containerId)) {
    return
  }

  let container = document.getElementById(containerId)
  if (!container) {
    container = document.createElement('div')
    container.id = containerId
    container.style.position = 'relative'
    container.style.zIndex = '2000'
    document.body.appendChild(container)
    createdContainers.add(containerId)
  }
}

// Patch querySelector to create containers on-demand
const originalQuerySelector = document.querySelector.bind(document)
const originalQuerySelectorAll = document.querySelectorAll.bind(document)

document.querySelector = function (selector: string) {
  const result = originalQuerySelector(selector)

  // If Element Plus is looking for a popper container that doesn't exist, create it
  if (!result && selector && selector.startsWith('#el-popper-container-')) {
    const containerId = selector.substring(1) // Remove the #
    ensurePopperContainer(containerId)
    return originalQuerySelector(selector)
  }

  return result
} as typeof document.querySelector

document.querySelectorAll = function (selector: string) {
  const result = originalQuerySelectorAll(selector)

  // If Element Plus is looking for popper containers that don't exist, create them
  if (
    result.length === 0
    && selector
    && selector.startsWith('#el-popper-container-')
  ) {
    const containerId = selector.substring(1) // Remove the #
    ensurePopperContainer(containerId)
    return originalQuerySelectorAll(selector)
  }

  return result
} as typeof document.querySelectorAll

// Ensure DOM is ready before mounting
function initApp() {
  // Check if app element exists
  const appElement = document.getElementById('app')
  if (!appElement) {
    console.error('App element not found. Retrying...')
    // Retry after a short delay
    setTimeout(initApp, 100)
    return
  }

  // Create base container
  ensurePopperContainer('el-popper-container')

  // Set up a mutation observer to ensure containers stay in body
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as Element
            // If Element Plus creates a container, ensure it's in body
            if (element.id && element.id.startsWith('el-popper-container')) {
              if (element.parentElement !== document.body) {
                document.body.appendChild(element)
              }
              createdContainers.add(element.id)
            }
          }
        })
      })
    })

    // Observe body for new elements
    observer.observe(document.body, {
      childList: true,
      subtree: false,
    })
  }

  // Mount the app
  app.mount('#app')
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp)
}
else {
  // DOM is already ready
  initApp()
}
